/**
 * The size advisor's shopper id on the order (see `sizeAdvisor.ts` for the widget itself). Apart
 * from the rest because the cart's add needs only this, and a plugin calls the add on every page:
 * importing `sizeAdvisor.ts` there would put all of the widget's mappers in the entry chunk.
 */

/** The widget's consent-aware API, which returns null when `data-consent="false"`. */
interface TapelineShopper {
  shopperId: () => unknown
}

/**
 * The shopper id as the backend stores it (vendure-app size-advisor `constants.ts`), which refuses
 * the whole mutation over one that does not match: up to 120 URL-safe characters.
 */
const SHOPPER_ID = /^[\w-]{1,120}$/

/**
 * The shopper id the widget keeps in this browser, which the order carries so the service can
 * match what was bought and returned to what it recommended. Read through the widget's API so
 * consent disabled on the script also ignores ids left in storage by an earlier release. Null
 * when the widget has not run, consent is disabled, or for a value the backend would refuse.
 */
export function readSizeAdvisorShopperId(widget?: TapelineShopper): string | null {
  try {
    const api = widget ?? (window as Window & { Tapeline?: TapelineShopper }).Tapeline
    const shopperId = api?.shopperId()
    return typeof shopperId === 'string' && SHOPPER_ID.test(shopperId) ? shopperId : null
  }
  catch {
    return null
  }
}

/**
 * The shopper id to write onto the order, or null when there is none in this browser or the order
 * carries it already.
 */
export function sizeAdvisorShopperIdToSet(shopperId: string | null, orderShopperId: string | null | undefined): string | null {
  return shopperId && shopperId !== orderShopperId ? shopperId : null
}
